import React, { useEffect, useState } from 'react';
import { useStyles } from './style';
import clsx from 'clsx';

const PaginationReport = ({
  currentPage,
  onChange,
  currentLength = 0,
  totalCountAll = 50

}) => {
  const [changeData, setChangeData] = useState(false); //با این فلگ از چندین بار درخواست کال شدن جلوگیری میکند
  const classes = useStyles();
  const [tempCurrentPage, setTempCurrentPage] = useState(1); //با این فلگ از چندین بار درخواست کال شدن جلوگیری میکند

  const totalCount = totalCountAll; // تعداد کل ایتم ها را در اینجا مشخص میکنیم

  useEffect(() => {
    // تابع مربوط به ایجاد آبجکت صفحه بندی همراه با چند نقطه
    onChange({
      page: Number(currentPage),
      pageSize: Number(totalCount),
      pageNumber: currentPage === 0 ? 0 : currentPage - 1,
      changeData: changeData,
    });
    setTempCurrentPage(currentPage)
    // در این onchange پارامتر ها و فلگر مربوط به تعداد صفحات و ایتم ها رو برای پرنت میفرستد.
  }, [currentPage]);


  const nextPage = (ischange) => {
    // تابع مربوط به کلید صفحه بعدی
    onChange({
      page: currentPage + 1,
      pageSize: totalCount,
      pageNumber: currentPage < 0 ? 0 : currentPage,
      changeData: ischange,
    });
  };

  const prevPage = (ischange) => {
    // تابع مربوط به دکمه صفحه قبلی
    onChange({
      page: currentPage - 1,
      pageSize: totalCount,
      pageNumber: currentPage < 0 ? 0 : currentPage - 2,
      changeData: ischange,
    });
  };

  return (
    <div className={classes.paginationBlock}>
      <div className={classes.pagination}>
        <button
          className={clsx(classes.pageItem)}
          type="button"
          onClick={() => {
            prevPage(true);
          }}
          disabled={currentPage === 1}
        >

          قبلی
        </button>

        <button
          type="button"
          key={currentPage}
          className={clsx(classes.pageItem, {
            active: currentPage === currentPage,
          })}

        >
          {tempCurrentPage}
        </button>
        <button
          type="button"
          className={clsx(classes.pageItem)}
          onClick={() => {
            nextPage(true);
          }}
          disabled={currentLength < totalCount || currentLength === 0}
        >

          بعدی
        </button>
      </div>

    </div>
  );
};

export default PaginationReport;
